module.exports = "/images/business-mirror.png?f357e89f4dc506b860b6e234eea529c3";